import { CA, FR } from '../../../constants/country-codes';
import { linkIDs } from '../../../services/link-service/links';
import newTermsAndAgreements from '../../../constants/new-terms-and-agreements';

export const configs = {
  [newTermsAndAgreements.canadaMar2021]: {
    country: CA,
  },
  [newTermsAndAgreements.franceJul2021]: {
    country: FR,
  },
  [newTermsAndAgreements.franceDec2021]: {
    country: FR,
  },
  terms: linkIDs.Shipstation2021Terms,
  privacy: linkIDs.Shipstation2021Privacy,
};
